import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import { clearFetchCache } from '@/lib/api/fetch';
import _ from 'lodash';
import { ROUTE_NAME_DUAL, ROUTE_NAME_ROOT, ROUTE_NAME_SUBDUAL, VIEW_ROUTE_CACHE_KEY } from '../constants';
import { SIDES } from '@/subview_plugins/install';

const prefix = '/patent-view';
Vue.use(Router);

function trackFromRouteRecord(record) {
    // [埋点] route 埋点
    const track = record.meta;
    if (track && track.trackEventName) {
        const props = Object.assign({}, track.trackProps || {});
        _.forEach(props, (value, key) => {
            if (typeof value === 'function') {
                props[key] = undefined;
                console.warn('🚧 TODO: track by function need refact!!!!');
            }
        });
        window.rvTrack(track.trackEventName, props);
    }
}

const router = new Router({
    base: prefix,
    mode: 'history',
    routes,
});

router.beforeEach((to, from, next) => {
    // 误删，给第三方接入首页跳转用
    window.currentRouteName = to.name;

    window.queryObj = to.query;
    if (from.query.patentId && (to.query.patentId !== from.query.patentId)) {
        // 每次变更id重置数据, 放在watch里太晚, 第一次除外，第一次有预先发的请求
        clearFetchCache();
    }
    next();
});

router.afterEach(to => {
    localStorage.setItem(VIEW_ROUTE_CACHE_KEY, JSON.stringify({ name: to.name, params: to.params, path: to.path } || {}));
    to.matched.forEach(record => {
        trackFromRouteRecord(record);
    });
});

export const getRouteNameList = ($route) => {
    const isDualViewRoute = $route.name === 'subDual';
    const list = isDualViewRoute ? [_.get($route, 'params.left'), _.get($route, 'params.right')] : [_.get($route, 'meta.pluginName')];
    return _.compact(list);
};

export const setDualViewRedirect = (left, right) => {
    router.addRoutes([
        {
            path: '/dual',
            name: ROUTE_NAME_DUAL,
            redirect: {
                name: ROUTE_NAME_SUBDUAL,
                params: {
                    [SIDES.LEFT]: left,
                    [SIDES.RIGHT]: right,
                },
            },
        },
    ]);
};

export const setRootRedirect = (isFamilySearch) => {
    const routeCache = JSON.parse(localStorage.getItem(VIEW_ROUTE_CACHE_KEY) || '{}');
    let redirectPath = '';
    if (isFamilySearch) {
        redirectPath = '/familySearchOverview';
    } else {
        redirectPath = (_.get(routeCache, 'name') === ROUTE_NAME_SUBDUAL) ? '/dual' : '/abst';
    }
    router.addRoutes([
        {
            path: '',
            name: ROUTE_NAME_ROOT,
            redirect: {
                path: redirectPath,
            },
        },
    ]);
};

export default router;
